<template>
  <div class="wrap">
    <div class="title">{{ title }}</div>
    <div class="filters">
      <div class="user" v-if="!noUserFilter">
        <v-text-field
          style="margin-top: -9px"
          v-model="filters.userId"
          label="User"
        ></v-text-field>
      </div>
      <div
        class="mr-3 date-picker"
        :style="{ marginLeft: noUserFilter ? '2rem' : '1rem' }"
      >
        <v-text-field
          :value="formatDate(filters.startDate)"
          label="Start Date"
          readonly
          @click="startModal = true"
        ></v-text-field>
      </div>
      <div class="date-picker">
        <v-text-field
          :value="formatDate(filters.endDate)"
          label="End Date"
          readonly
          @click="endModal = true"
        ></v-text-field>
      </div>
      <div class="status" v-if="!noUserStatus && this.context === 'add'">
        <vue-select
          :options="statuses1"
          v-model="filters.status"
          placeholder="Status"
        />
      </div>
      <div class="status" v-if="!noUserStatus && this.context === 'renew'">
        <vue-select
          :options="statuses1"
          v-model="filters.status"
          placeholder="Status"
        />
      </div>
      <div class="status" v-if="!noUserStatus && this.context === 'payments'">
        <vue-select
          style="width: 150px"
          :options="paymentTypes"
          v-model="filters.selected"
          placeholder="Payments"
        />
      </div>
      <div class="status" v-if="!noUserStatus && this.context === 'payments'">
        <vue-select
          style="width: 160px"
          :options="statuses"
          v-model="filters.status"
          placeholder="Status"
        />
      </div>
      <div class="status" v-if="!noUserStatus && this.context === 'quickpay'">
        <vue-select
          :options="statuses"
          v-model="filters.status"
          placeholder="Status"
        />
      </div>
      <div class="status" v-if="!noUserStatus && this.context === 'users'">
        <vue-select
          :options="statuses3"
          v-model="filters.status"
          placeholder="Status"
        />
      </div>
      <div
        class="status"
        v-if="!noUserStatus && this.context === 'serviceRequests'"
      >
        <vue-select
          :options="statuses2"
          v-model="filters.status"
          placeholder="Status"
        />
      </div>

      <v-btn color="primary" @click="handleSubmit" class="mt-3 ml-2"
        >Submit</v-btn
      >
      <v-btn
        color="primary"
        @click="handleCSV"
        v-if="items && items.length > 0"
        class="mt-3 ml-2"
        >Download</v-btn
      >
    </div>
    <v-dialog
      ref="startDialog"
      v-model="startModal"
      :return-value.sync="filters.startDate"
      persistent
      width="290px"
    >
      <v-date-picker v-model="filters.startDate" scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="cancelModal('startDate')"
          >Cancel</v-btn
        >
        <v-btn
          text
          color="primary"
          @click="
            () => {
              $refs.startDialog.save(filters.startDate);
              this.startModal = false;
            }
          "
          >OK</v-btn
        >
      </v-date-picker>
    </v-dialog>
    <v-dialog
      ref="dialog"
      v-model="endModal"
      :return-value.sync="filters.endDate"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on }"></template>
      <v-date-picker v-model="filters.endDate" scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="cancelModal('endDate')"
          >Cancel</v-btn
        >
        <v-btn
          text
          color="primary"
          @click="
            () => {
              $refs.dialog.save(filters.endDate);
              this.endModal = false;
            }
          "
          >OK</v-btn
        >
      </v-date-picker>
    </v-dialog>
    <div style="margin: 40px">
      <v-data-table :items="items" :headers="columns" :loading="loading">
        <template v-slot:header.totalCharge>
          <div class="d-flex">
            <v-select
              v-model="local.totalChargeSym"
              :items="symbols"
              class="symbol"
            />
            <v-text-field
              label="Total Charge"
              v-model="local.totalCharge"
              class="value"
            />
          </div>
        </template>
        <template v-slot:header.ncf>
          <div class="d-flex">
            <v-select v-model="local.ncfSym" :items="symbols" class="symbol" />
            <v-text-field label="NCF" v-model="local.ncf" class="value" />
          </div>
        </template>
        <template v-slot:header.master.planType>
          <v-select
            v-model="local.planType"
            :items="local.planTypeOptions"
            class="value"
            placeholder="Plan Type"
          />
        </template>
        <template v-slot:header.master.planName>
          <v-text-field
            v-model="local.planName"
            class="value"
            label="Plan Name"
          />
        </template>
        <template v-slot:item.id="{ item }">
          <div>{{ item.id }}</div>
        </template>
        <template v-slot:item.dp="{ item }">
          <div>{{ item.dp ? "DP" : "FR" }}</div>
        </template>
        <template v-slot:item.otpVerify="{ item }">
          <div>{{ item.otpVerify ? "YES" : "NO" }}</div>
        </template>

        <template
          v-if="context === 'serviceRequests'"
          v-slot:item.status="{ item }"
        >
          <div>{{ item.status ? "CLOSED" : "OPEN" }}</div>
        </template>

        <template v-slot:item.totalCharge="{ item }">
          <div>{{ roundToTwo(item.totalCharge) }}</div>
        </template>
        <template v-slot:item.ncf="{ item }">
          <div>{{ roundToTwo(item.ncf) }}</div>
        </template>
        <template v-slot:item.transactionDate="{ item }">
          <div>{{ new Date(item.transactionDate).toLocaleString() }}</div>
        </template>
        <template v-slot:item.createdDate="{ item }">
          <div>{{ new Date(item.createdDate).toLocaleString() }}</div>
        </template>
        <template v-slot:item.userProfile.createdDate="{ item }">
          <div>
            {{ new Date(item.userProfile.createdDate).toLocaleString() }}
          </div>
        </template>

        <template v-slot:item.trancationDate="{ item }">
          <div>{{ new Date(item.trancationDate).toLocaleString() }}</div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon class="closebtn mr-2" @click="statusToggle(item)"
            >mdi-close-box</v-icon
          >
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { listUsers as listUserService } from "../../services/user";
import vueSelect from "vue-select";
import { extractError } from "../../utils/error";
import toCSV from "../../utils/csv";
import {
  paymentColumns,
  quickpayColumns,
  addColumns,
  userColumns,
  serviceRequestsColumns,
} from "./config";
// import { log } from "util";
import { closeServiceRequest } from "@/services/serviceRequest";
import { fetchEasyBuzzPayments } from "@/services/report";
export default {
  components: {
    vueSelect,
  },
  data() {
    return {
      loading: false,
      items: [],
      startModal: "",
      endModal: "",
      symbols: [">", "<", ">=", "<=", "=="],
      editedIndex: -1,
      local: {
        totalCharge: "",
        totalChargeSym: "<",
        ncf: "",
        ncfSym: "<",
        planName: "",
      },
      paymentTypes: [
        {
          label: "PayTM",
          value: "PAYTM",
        },
        {
          label: "EaseBuzz",
          value: "EASYBUZZ",
        },
      ],
      statuses: [
        {
          label: "Success",
          value: "TXN_SUCCESS",
        },
        {
          label: "Failure",
          value: "TXN_FAILURE",
        },
      ],
      statuses1: [
        {
          label: "Success",
          value: "SUCCESS",
        },
        {
          label: "Failure",
          value: "FAILED",
        },
      ],
      statuses2: [
        {
          label: "CLOSED",
          value: "CLOSED",
        },
        {
          label: "OPEN",
          value: "OPEN",
        },
      ],
      statuses3: [
        {
          label: "VERIFIED",
          value: "VERIFIED",
        },
        {
          label: "NOT VERIFIED",
          value: "NOT VERIFIED",
        },
      ],

      filters: {
        userId: null,
        startDate: null,
        endDate: null,
        status: null,
        selected: {
          label: "PayTM",
          value: "PAYTM",
        },
      },

      users: [],
    };
  },
  props: {
    noUserFilter: Boolean,
    remoteService: Function,
    context: String,
    noUserStatus: Boolean,
  },
  computed: {
    userOptions() {
      return this.users.map((u) => ({
        label: u.accountNo,
        code: u._links.self.href,
      }));
    },
    csvRows() {
      if (!this.items) return [];
      if (["add", "renew"].includes(this.context)) {
        let result = [
          [
            "Payment Id",
            "Account No",
            "Plan Code",
            "Amount",
            "NCF Price",
            "Plan Type",
            "OpEntity",
            "Plan Name",
            "Status",
            "Created On",
          ],
        ];
        result = result.concat(
          this.items.map((item) => [
            item.paymentId,
            item.accountNo,
            item.planCode,
            this.roundToTwo(item.totalCharge),
            this.roundToTwo(item.ncf),
            item.planType,
            item.opentity_CODE,
            item.planName,
            item.status,
            new Date(item.transactionDate).toLocaleString(),
          ])
        );
        return result;
      }
      if (this.context === "users") {
        let result = [
          [
            "Account No",
            "Email",
            "Name",
            "Mobile",
            "Serial No",
            "OTP verified",
            "Serial No Type",
            "Customer Type",
            "Op Entity",
            "District",
            "Balance",
            "Date Time",
          ],
        ];
        result = result.concat(
          this.items.map((item) => [
            item.accountNo,
            item.email,
            item.customer_NAME,
            item.mobile,
            item.serialNo,
            item.otpVerify ? "YES" : "NO",
            item.serialNoType,
            item.dp ? "DP" : "FR",
            item.opentity_CODE,
            item.district_CODE,
            item.walletBalance,
            new Date(item.createdDate).toLocaleString(),
          ])
        );
        return result;
      }
      if (this.context === "serviceRequests") {
        let result = [
          [
            "ID",
            "Category Name",
            "Sub Category Name",
            "Created By",
            "Mobile No",
            "Account No",
            "Created On",
            "Status",
            "Comments",
            "Actions",
          ],
        ];
        result = result.concat(
          this.items.map((item) => [
            item.id,
            item.categoryName,
            item.subCategoryName,
            item.createdBy,
            item.mobile,
            item.accountNo,
            new Date(item.createdDate).toLocaleString(),
            item.status,
            item.comments,
            item.action,
          ])
        );
        return result;
      }
      if (this.context === "payments") {
        let result = [
          [
            "Payment ID",
            "Subscriber ID",
            "Amount",
            "Transaction ID",

            "Transaction Date",
            "Status",
          ],
        ];
        result = result.concat(
          this.items.map((item) => [
            item.paymentMqNo,
            item.accountNo,
            this.roundToTwo(item.amount),
            item.trancationId,

            new Date(item.trancationDate).toLocaleString(),
            item.status,
          ])
        );
        return result;
      }
    },
    filterBy() {
      let { userId, startDate, endDate, status, selected } = this.filters;
      if (!this.isAdmin) {
        userId = this.userId;
      }
      if (userId) {
        if (startDate && endDate) {
          if (!(status && status.value)) return 2;
          return 3;
        }
        if (status && status.value) return 4;
        return 1;
      }
      // user id is null
      else {
        if (!status && startDate && endDate) {
          return 5;
        }
        if (status && !startDate && !endDate) {
          return 7;
        }
        return 6;
      }
    },
    columns() {
      const options = {
        excludeUser: !this.isAdmin,
        totalChargeFilter: this.numberFilter("totalCharge"),
        ncfFilter: this.numberFilter("ncf"),
        nameFilter: this.textFilter("planName"),
        planTypeFilter: this.selectFilter("planType"),
      };
      if (this.context === "payments") {
        return paymentColumns(options);
      }
      if (this.context === "quickpay") {
        return quickpayColumns(options);
      }
      if (this.context === "add") {
        return addColumns(options);
      }
      if (this.context === "users") {
        return userColumns();
      }
      if (this.context === "serviceRequests") {
        return serviceRequestsColumns();
      }
      return addColumns(options);
    },
    title() {
      // ``;
      const { context } = this;
      if (context === "add") return "Activation Report";
      if (context === "renew") return "Renewal Report";
      if (context === "payments") return "Topup Report";
      if (context === "quickpay") return "Quickpay Report";
      if (context === "users") return "Registration Report";
      if (context === "serviceRequests") return "Service Requests";
      // return "Topup Report";
    },
  },
  methods: {
    roundToTwo(num) {
      return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
    },
    numberFilter(prefix) {
      return (value) => {
        if (!this.local[prefix]) return true;
        const symbol = this.local[prefix + "Sym"];
        const limit = this.local[prefix];
        return eval(`${value} ${symbol} ${limit}`);
      };
    },
    selectFilter(prefix) {
      return (value) => {
        if (!this.local[prefix]) return true;
        const query = this.local[prefix];
        return value === query;
      };
    },
    textFilter(prefix) {
      return (value) => {
        if (!this.local[prefix]) return true;
        const query = this.local[prefix];
        return value.toLowerCase().includes(query.toLowerCase());
      };
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    cancelModal(which) {
      this.startModal = false;
      this.endModal = false;
      this.filters[which] = "";
    },
    giveRange(min, max) {
      const diff = max - min;
      let steps = 0;
      const stepSize = parseInt(diff / 10);
      const result = [];
      while (steps < 10) {
        result.push(parseInt(min + stepSize * steps));
        steps += 1;
      }
      return result;
    },
    handleCSV() {
      toCSV(this.csvRows, this.title + ".csv");
    },
    async statusToggle(item) {
      // console.log("status change");
      /*eslint-disable no-unused-vars*/
      const result = await closeServiceRequest(item.id, {});

      window.location.reload();
      this.$toasted.success("Successfully Closed", {
        duration: 3000,
      });
    },
    async handleSubmit() {
      if (
        this.filters.selected == null ||
        this.filters.selected.value == "PAYTM"
      ) {
        try {
          const { context } = this;
          this.loading = true;
          this.items = [];
          const remoteService = this.remoteService;
          const payload = { ...this.filters };
          payload.filterBy = this.filterBy;
          // console.log("filters is : ", this.filters);
          if (payload.userId) {
            // console.log("userid is bharelu");
            const group = payload.userId.match(/users.*(\d)+$/);
            const userId = group[1];
            payload.userId = userId;
          }
          if (payload.status) payload.status = payload.status.value;
          if (payload.selected) payload.selected = payload.selected.value;

          const result = await remoteService(payload);
          // eslint-disable-next-line
          console.log("got response : ", result);
          const planTypeOptions = [];
          if (context !== "users" && context !== "serviceRequests") {
            this.items = result.map((r) => {
              const planType = r.master ? r.master.planType : null;
              if (planType && !planTypeOptions.includes(planType)) {
                planTypeOptions.push(planType);
              }
              return {
                ...r,
                userName: r.accountNo + " " + r.accountNo,
              };
            });
          } else {
            this.items = result;
          }

          this.local.planTypeOptions = planTypeOptions;
          this.loading = false;
        } catch (err) {
          // eslint-disable-next-line
          console.log(err);
          this.loading = false;
          const message = extractError(err);
          this.$showError(message);
        }
      } else if (this.filters.selected.value == "EASYBUZZ") {
        try {
          const { context } = this;
          this.loading = true;
          this.items = [];
          const remoteService = this.remoteService;
          const payload = { ...this.filters };
          payload.filterBy = this.filterBy;
          // console.log("filters is : ", this.filters);
          if (payload.userId) {
            // console.log("userid is bharelu");
            const group = payload.userId.match(/users.*(\d)+$/);
            const userId = group[1];
            payload.userId = userId;
          }
          //   if (payload.status) payload.status = payload.status.value;
          if (payload.status)
            payload.status =
              payload.status.value == "TXN_SUCCESS" ? "SUCCESS" : "FAILED";
          if (payload.selected) payload.selected = payload.selected.value;

          const result = await fetchEasyBuzzPayments(payload);
          // eslint-disable-next-line
          console.log("got response : ", result);
          const planTypeOptions = [];
          if (context !== "users" && context !== "serviceRequests") {
            this.items = result.map((r) => {
              const planType = r.master ? r.master.planType : null;
              if (planType && !planTypeOptions.includes(planType)) {
                planTypeOptions.push(planType);
              }
              return {
                ...r,
                userName: r.accountNo + " " + r.accountNo,
              };
            });
          } else {
            this.items = result;
          }

          this.local.planTypeOptions = planTypeOptions;
          this.loading = false;
        } catch (err) {
          // eslint-disable-next-line
          console.log(err);
          this.loading = false;
          const message = extractError(err);
          this.$showError(message);
        }
      }
    },
    setup() {
      const today = new Date();
      const todayParsed =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const lastDay = new Date(today.getTime() + 24 * 60 * 60 * 1000);
      const lastDayParsed =
        lastDay.getFullYear() +
        "-" +
        (lastDay.getMonth() + 1) +
        "-" +
        lastDay.getDate();
      this.filters.startDate = todayParsed;
      this.filters.endDate = lastDayParsed;
      this.handleSubmit();
    },
  },
  watch: {
    context: function () {
      this.items = [];
      this.filters.userId = null;
      this.filters.status = null;
      this.filters.selected = null;
      this.local = {};
      this.setup();
    },
  },
  async mounted() {
    try {
      const { context } = this;
      const users = context === "users" ? [] : await listUserService();
      // eslint-disable-next-line
      console.log("got users : ", users);
      this.users = users;
      const today = new Date();
      const todayParsed =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const lastDay = new Date(today.getTime() + 24 * 60 * 60 * 1000);
      const lastDayParsed =
        lastDay.getFullYear() +
        "-" +
        (lastDay.getMonth() + 1) +
        "-" +
        lastDay.getDate();
      this.filters.startDate = todayParsed;
      this.filters.endDate = lastDayParsed;
      this.handleSubmit();
    } catch (err) {
      // eslint-disable-next-line
      console.log(err);
    }
  },
};
</script>

<style>
.mdi-arrow-up {
  position: absolute;
  top: 23px;
  right: 5px;
}
.wrap .v-label {
  font-weight: 600;
  font-family: Roboto, sans-serif;
}
th {
  position: relative;
}
.wrap thead input,
.wrap thead label,
.mdi {
  color: #ffffff !important;
  font-weight: 500;
}
tbody tr:nth-child(2n + 1) {
  background: #eceeee;
}
.wrap .v-select__selection {
  color: #fff;
  font-weight: 500;
}
.wrap .v-data-footer .v-select__selection {
  color: #000;
  font-weight: 500;
}
.mdi-chevron-right::before {
  color: grey;
}

.mdi-menu-down::before {
  color: grey;
}
.mdi-chevron-left::before {
  color: grey;
}

.wrap .v-data-footer {
  color: black !important;
}
.wrap .v-select * {
  font-weight: 500;
}
.wrap thead * {
  color: #ffffff;
}
.wrap thead,
tfoot {
  color: white !important;
  background-image: linear-gradient(
    225deg,
    #59065d 0%,
    #8d0b93 50%,
    #061d48 100%
  );
}
</style>

<style lang="scss" scoped>
.symbol {
  max-width: 70px !important;
  margin-right: 1rem;
}
.value {
  min-width: 120px;
  max-width: 160px;
  font-family: Roboto, sans-serif;
}
.wrap {
  margin-top: 30px;
}
.title {
  margin-right: 1320px;
}
.filters {
  display: flex;
  margin: 0 20px 0 20px;

  .user {
    margin: 12px 20px;
    transition: all 0.3s ease;
    width: 400px;
  }
}
.date-picker {
  width: 250px;
}
.status {
  width: 150px;
  margin: 15px 5px 0 15px;
}
.status ul {
  padding: 0 !important;
}
</style>
<style>
ul {
  padding: 0 !important;
}
.closebtn {
  background: #400648 !important;
}
.header-container {
  display: flex;
  flex-direction: row;
}
</style>
